import React from 'react';

// Bootstrap Components
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import heroImage from '../../../../assets/images/home/home-v1.png';

const HeroSection = () => {
  return (
    <section className="hero-home image" id="hero">
      <Container fluid="lg">
        <Row className="hero-home__content">
          <Col lg={6} className="hero-home__data">
            <h1 className="hero-home__title">
              <span className="hero-home__title-name">Carolina Ackermann</span>
              <span className="hero-home__title-description">
                Investigadora, educadora y consultora en cultura menstrual y
                menopausia
              </span>
              <span className="hero-home__title-brand">Mujer Sin Reglas</span>
            </h1>
            <p className="hero-home__event">Próximo evento</p>
          </Col>
          <Col lg={6} className="hero-home__visual-col">
            <img
              src={heroImage}
              className="hero-home__visual"
              alt="Carolina Ackermann en la portada de Mujer Sin Reglas"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
